import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { InnerLayout, LayoutContainer } from 'components/layout/styled';

export const Wrapper = Box;

export const ProductOrderReviewWrapper = Box.withConfig({
  flex: 1,
  margin: 0,
  padding: 0,
});

export const Container = Box.withConfig({
  width: 'full',
  height: 'auto',
  paddingTop: '12px',
  alignItems: 'center',
  display: 'flex',
});

export const ProductTitle = withTypography({
  accessible: true,
  variant: 'headerTwo',
  m: '$0',
  fontSize: '2xl',
  px: '$8',
  textAlign: 'center',
  lineHeight: 33,
  style: { paddingBottom: 12 },
});

export const ProductOrderReviewContainer = Box.withConfig({
  flex: 1,
  margin: 0,
  padding: 0,
  marginTop: {
    base: '$4',
    md: '$8',
  },
});

export const ProductReviewLayoutContainer = LayoutContainer.withConfig({
  marginY: 0,
  paddingY: 0,
});

export const ProductOrderReviewInnerLayout = InnerLayout.withConfig({
  marginY: 0,
  paddingY: 0,
});
